import "@hotwired/turbo-rails";
import "./controllers";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import "ahoy.js";
import "./coloris.min";

import * as echarts from "echarts";
window.echarts = echarts;

Coloris({
  themeMode: 'auto',
  swatches: [
    '#ef4444',
    '#fb923c',
    '#22c55e',
    '#7dd3fc',
    '#fde047',
    '#a78bfa',
    '#f472b6',
    '#d4d4d4',
    '#c2410c',
    '#991b1b',
    '#15803d',
    '#525252'
  ],
});

document.addEventListener("submit", (event) => {
  const form = event.target;
  if (form.closest('[data-turbo="false"]')) {
    let submitButtons = Array.from(form.querySelectorAll('input[type="submit"], button[type="submit"]'));

    if (form.id) {
      const externalButtons = document.querySelectorAll(`button[form="${form.id}"], input[form="${form.id}"]`);
      submitButtons = submitButtons.concat(Array.from(externalButtons));
    }

    submitButtons.forEach((button) => {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.value || button.innerText;
      }

      if (button.dataset.disableWith) {
        if (button.tagName === "INPUT") {
          button.value = button.dataset.disableWith;
        } else {
          button.innerText = button.dataset.disableWith;
        }
      }

      setTimeout(() => { button.disabled = true; }, 0);
    });
  }
});

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    document.querySelectorAll('input[type="submit"], button[type="submit"]').forEach((button) => {
      button.disabled = false;
      if (button.dataset.originalText) {
        if (button.tagName === "INPUT") {
          button.value = button.dataset.originalText;
        } else {
          button.innerText = button.dataset.originalText;
        }
      }
    });
  }
});

